import { ActionTypes as actions } from '../actions';

const initialState = {
  activeConsultations: null,
  resolvedConsultations: null,
  processingConsultations: null,
  unassignedConsultations: null,
  allConsultations: null,
  consultationMessages: null,
  consultationParticipants: {},   // Obj[consultation_id] = [participants];
  selectedConsultation: null,
  selectedTab: null,
  consultationFrontDeskTasks: null, // key:value key: consultation_id value: array of tasks
  consultationMedicalRecords: null, // key:value key: consultation_id value: array of records
  consultationsScreenState: null,
  previewConsultations: null,       // key:value example { ACTIVE: [{}, {}, {}], RESOLVED: [{}, {}, {}] }
  seeAllConsultations: null,
  seeAllConsultationsStatus: '',
  seeAllConsultationsPageState: {},
}

export default function ContextReducer(state=initialState, action) {

  switch(action.type) {
    case actions.PRACTICE_ACTIVE_CONSULTATIONS_UPDATE:
      state = { ...state, activeConsultations: action.payload };
      break;
    case actions.PRACTICE_RESOLVED_CONSULTATIONS_UPDATE:
      state = { ...state, resolvedConsultations: action.payload };
      break;
    case actions.PRACTICE_PROCESSING_CONSULTATIONS_UPDATE:
      state = { ...state, processingConsultations: action.payload };
      break;
    case actions.PRACTICE_UNASSIGNED_CONSULTATIONS_UPDATE:
      state = { ...state, unassignedConsultations: action.payload };
      break;
    case actions.CONSULTATION_SELECTED_UPDATE:
      state = { ...state, selectedConsultation: action.payload };
      break;
    case actions.CONSULTATION_UPDATE_PARTICIPANTS:
      const participants  = action.payload;
      if (participants.consultation_id && state.consultationParticipants) {
        state.consultationParticipants[participants.consultation_id] = participants.participants;
        state = { ...state, consultationParticipants: state.consultationParticipants };
      } else {
        let consult_parts = {};
        consult_parts[participants.consultation_id] = participants.participants;
        state = { ...state, consultationParticipants: consult_parts };
      }
      break;
    case actions.CONSULTATION_ADD_CONSULTATION_DETAIL:
      var consultations = state.allConsultations ? Object.assign({}, state.allConsultations) : {};
      const consultationToAdd = action.payload;
      consultations[consultationToAdd._id] = consultationToAdd;
      state = { ...state, allConsultations: consultations }
      break;
    case actions.CONSULTATION_UPDATE_CONSULTATION_RECORDS:
      const consultRecordsData = action.payload;
      if (consultRecordsData.consultation_id && consultRecordsData.data) {
        var updatedConsulRecords = state.consultationMedicalRecords ? Object.assign({}, state.consultationMedicalRecords) : {};
        updatedConsulRecords[consultRecordsData.consultation_id] = consultRecordsData.data;
        state = { ...state, consultationMedicalRecords: updatedConsulRecords };
      }
      break;
    case actions.CONSULTATION_UPDATE_CONSULTATION_TASKS:
      const consultTasksData = action.payload;
      if (consultTasksData.consultation_id && consultTasksData.data) {
        var updatedConsulTasks = state.consultationFrontDeskTasks ? Object.assign({}, state.consultationFrontDeskTasks) : {};
        updatedConsulTasks[consultTasksData.consultation_id] = consultTasksData.data;
        state = { ...state, consultationFrontDeskTasks: updatedConsulTasks };
      }
      break;
    case actions.CONSULTATION_UPDATE_INFO:
      let new_consultations = action.payload || [];
      let existing_consults = Object.assign({}, state.allConsultations);
      new_consultations.forEach((consultation) => {
        existing_consults[consultation._id] = consultation;
      });
      state = { ...state, allConsultations: existing_consults };
      break;
    case actions.CONSULTATION_SELECTED_TAB:
      state = { ...state, selectedTab: action.payload };
      break;
    case actions.CONSULTATIONS_SCREEN_STATE_UPDATE:
      state = { ...state, consultationsScreenState: action.payload };
      break;
    case actions.CONSULTATION_UPDATE_PREVIEWS:
      state = { ...state, previewConsultations: action.payload };
      break;
    case actions.CONSULTATION_UPDATE_SEE_ALL:
      state = { ...state, seeAllConsultations: action.payload };
      break;
    case actions.CONSULTATION_UPDATE_SEE_ALL_STATUS:
      state = { ...state, seeAllConsultationsStatus: action.payload };
      break;
    case actions.CONSULTATION_UPDATE_SEE_ALL_PAGE_STATE:
      state = { ...state, seeAllConsultationsPageState: action.payload };
      break;
    case actions.CONSULTATIONS_CLEAR_DATA:
      state = {
        ...state,
        activeConsultations: null,
        resolvedConsultations: null,
        processingConsultations: null,
        unassignedConsultations: null,
      };
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    default:

  }

  return state;
}
